<div class="container container-padding">

    <h1 class="page-header">{{'LABEL.FRONTIER_HEADER' | translate}}</h1>

    <div class="row form-row align-items-center">
        <div class="col"><h3 class="page-subheader">{{ 'LOCATION_DIALOG.SUBHEADER' | translate }}</h3>
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4">
            <app-input [label]="'CITY' | translate"
                       [(ngModel)]="request.location"
                       [errorStateMatcher]="matchers.location">
            </app-input>
        </div>
        <div class="col-2">
            <app-select
                    [ngModel]="request.insurancePeriod?.code"
                    [label]="'LABEL.INSURANCE_PERIOD' | translate"
                    (ngModelChange)="request.insurancePeriod = {code: $event}"
                    [itemList]="(dictionaries$|async)[dictionaryTypes.INSURANCE_PERIOD].itemList"
                    [hasEmpty]="false"
                    [errorStateMatcher]="matchers.insurancePeriod">
            </app-select>
        </div>
        <div class="col-2">
            <app-datepicker
                    [(ngModel)]="request.insuranceStartDate"
                    [minToday]="true"
                    [max]="todayPlus30"
                    [errorStateMatcher]="matchers.insuranceStartDate"
                    [label]="'OFFER_CONFIG.INSURANCE_DATE_FROM' | translate">
            </app-datepicker>
        </div>
    </div>


    <app-party-form [title]="'LABEL.POLICYHOLDER_AND_INSURED' | translate"
                    [blockPeselForForeigner]="false"
                    [noPeselLabel]="'LABEL.FOREIGNER'"
                    [companyAllowed]="true"
                    prefix="party"
                    [allowForeignAddress]="true"
                    [party]="request.party">
    </app-party-form>

    <div class="row form-row">
        <div class="col-1">
            <app-input-mask
                    [textMask]="{mask: '+000', lazy: true}"
                    [(ngModel)]="request.contactData.phonePrefix"
                    [errorStateMatcher]="matchers.contactData.phonePrefix"
                    [label]="'LABEL.PHONE_PREFIX' | translate">
            </app-input-mask>
        </div>
        <div class="col-3">
            <app-input-mask
                    [textMask]="{mask: '000 000 000', lazy: true}"
                    [(ngModel)]="request.contactData.phoneNumber"
                    [errorStateMatcher]="matchers.contactData.phoneNumber"
                    [label]="'LABEL.PHONE_NUMBER' | translate">
            </app-input-mask>
        </div>
        <div class="col-4">
            <app-input
                    [(ngModel)]="request.contactData.email"
                    [errorStateMatcher]="matchers.contactData.email"
                    [label]="'LABEL.EMAIL' | translate">
            </app-input>
        </div>
    </div>

    <app-eurotax-form [title]="'MOTOR_CONFIG.MOTOR_DATA_EUROTAX' | translate"
                      [data]="request.vehicleDefinition"
                      [aside]="false"
                      prefix="vehicleDefinition">
    </app-eurotax-form>

    <app-car-manual-form [data]="request.vehicleDefinition"
                         *ngIf="request.vehicleDefinition.mode === vehicleDefinitionMode.MANUAL"
                         [title]="'MOTOR_CONFIG.MOTOR_DATA_MANUAL' | translate"
                         [aside]="false"
                         prefix="vehicleDefinition">
    </app-car-manual-form>

    <div class="row form-row">
        <div class="col-4">
            <app-input
                    [label]="'MOTOR_CONFIG.REGISTRATION_NUMBER' | translate"
                    [(ngModel)]="request.vehicleDefinition.licensePlate"
                    [errorStateMatcher]="matchers.vehicleDefinition.licensePlate">
            </app-input>
        </div>

        <div class="col-4">
            <app-input
                    [label]="'MOTOR_CONFIG.VIN' | translate"
                    [maxLength]="17"
                    [(ngModel)]="request.vehicleDefinition.vin"
                    [errorStateMatcher]="matchers.vehicleDefinition.vin">
            </app-input>
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4">
            <app-select
                    [ngModel]="request.vehicleOriginCountry?.code"
                    [label]="'LABEL.VEHICLE_ORIGIN_COUNTRY' | translate"
                    (ngModelChange)="request.vehicleOriginCountry = {code: $event}"
                    [itemList]="(dictionaries$|async)[dictionaryTypes.COUNTRY].itemList"
                    [errorStateMatcher]="matchers.vehicleOriginCountry">
            </app-select>
        </div>
    </div>

    <div class="row form-row align-items-center mt-4 mb-4">
        <div class="col-12">
            <h3 class="page-subheader">{{ 'LABEL.PAYMENT' | translate }}</h3>
        </div>
        <div class="col-12">
            {{ 'LABEL.PAYMENT_TYPE_HEADER1' | translate }}
        </div>
        <div class="col-12">
            {{ 'LABEL.PAYMENT_TYPE_HEADER2' | translate }}
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4">
            <app-select
                    [ngModel]="request.paymentType?.code"
                    [label]="'LABEL.PAYMENT_TYPE' | translate"
                    (ngModelChange)="request.paymentType = {code: $event}"
                    [hasEmpty]="false"
                    [itemList]="(dictionaries$|async)[dictionaryTypes.PAYMENT_TYPE].itemList"
                    [errorStateMatcher]="matchers.paymentType">
            </app-select>
        </div>
    </div>

    <div class="row form-row">
        <div class="col">
            <app-errors [errorStateMatcher]="matchers.all"
                        [bigger]="true"></app-errors>
        </div>
    </div>

    <div class="row">
        <div class="col-4">
            <button class="btn btn-primary btn-block mt-4"
                    (click)="submit()">
                {{ 'LABEL.GO_TO_SUMMARY' | translate }}
            </button>
        </div>
    </div>
</div>
